import { useState, useContext } from "react";

import { Stack, Checkbox, CheckboxProps, Typography, Box } from "@mui/material";

import { SettingsOptionsContext } from "../SettingsOptions";

interface SettingsCheckboxProps extends CheckboxProps {
  /**
   * Acts as the identifier of the settings option.
   */
  keyid: string;
  /**
   * Label to be displayed in the UI
   */
  label: string;
}

export default function SettingsCheckbox(props: SettingsCheckboxProps) {
  const settignsOptions = useContext(SettingsOptionsContext);
  const [isChecked, setIsChecked] = useState<boolean>(props.checked ?? true);

  return (
    <Stack direction="row" sx={{
      alignItems: "center"
    }}>
      <Typography sx={{ flex: 1 }}>{props.label}</Typography>
      <Box sx={{ flex: 2 }}>
        <Checkbox
          checked={isChecked}
          onChange={(e, checked) => {
            settignsOptions?.updateSettingsState(props.keyid, checked);
            setIsChecked(checked);
          }}
        />
      </Box>
    </Stack>
  );
};